import React from 'react';

import PropTypes from '+/instances/propTypesInstance';
import { StyledColumn, StyledDiv } from '+/styledComponents/elements/containers';
import { StyledCheckbox, StyledLabel, StyledCheckboxLabel } from '+/styledComponents/elements/forms';
import StyledInputBlock from '+/styledComponents/StyledInputBlock';
import TextReader from '+/utils/TextReader';

const { t } = new TextReader('forms');

export function checkAllChildrenCheckboxes(boxes, values, setFieldValue, nestedKey) {
  const allChecked = boxes.every(box => values[box.name]);
  if (!allChecked) {
    if (nestedKey) {
      const newValue = boxes.reduce(
        (accum, box) => ({
          ...accum,
          [box.name]: true,
        }),
        {},
      );
      setFieldValue(nestedKey, newValue);
    } else {
      const unchecked = boxes.filter(box => !values[box.name]);
      unchecked.forEach(box => setFieldValue(box.name, true));
    }
  } else if (nestedKey) {
    const newValue = boxes.reduce(
      (accum, box) => ({
        ...accum,
        [box.name]: false,
      }),
      {},
    );
    setFieldValue(nestedKey, newValue);
  } else {
    boxes.forEach(box => setFieldValue(box.name, false));
  }
}

export const CheckboxList = ({
  // array of objects { name: XX, label: XX }
  // name is the name of the field for formik
  // label is what is displayed to user
  // value is true or false
  boxes,
  touched,
  label = null,
  submitCount,
  handleChange,
  handleBlur,
  values,
  errors,
  danger = false,
  setFieldValue,
  isArrayValue = false, // names are to be set in html array format name='name[value]'
  name = null,
  allowSelectAll = true,
}) => {
  const nestedKey = isArrayValue ? name : null;
  const relevantValues = isArrayValue ? values[nestedKey] : values;

  return (
    <StyledDiv>
      {allowSelectAll && (
        <StyledLabel inline>
          <StyledCheckbox
            onChange={() => {
              checkAllChildrenCheckboxes(boxes, relevantValues, setFieldValue, nestedKey);
            }}
            value={boxes.every(box => relevantValues[box.name])}
            aria-label={label || t('selectAll')}
          />
          <StyledCheckboxLabel>{label || t('selectAll')}</StyledCheckboxLabel>
        </StyledLabel>
      )}
      <StyledColumn leftPadded={allowSelectAll} lessLeftPadded={!allowSelectAll}>
        {boxes.map(box => {
          const fieldName = isArrayValue ? `${name}[${box.name}]` : box.name;
          return (
            <StyledInputBlock
              disabled={box.required}
              key={box.name}
              handleChange={handleChange}
              handleClick={handleChange}
              handleBlur={handleBlur}
              errors={errors}
              values={values}
              touched={touched}
              label={box.label}
              submitCount={submitCount}
              danger={danger}
              name={fieldName}
              fieldType="checkbox"
              decorative={box.required}
            />
          );
        })}
      </StyledColumn>
    </StyledDiv>
  );
};

CheckboxList.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  boxes: PropTypes.array.isRequired,
  label: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  touched: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  errors: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  submitCount: PropTypes.number.isRequired,
  danger: PropTypes.bool,
  setFieldValue: PropTypes.func.isRequired,
  name: PropTypes.string,
  isArrayValue: PropTypes.bool,
  allowSelectAll: PropTypes.bool,
};
